<template>
  <SideBar :width="getSideBarWidth()" :isMobile="isMobile">
    <template #side-bar-activator>
      <Activator
        class="self-centered cursor-e-resize"
        :key="`side_bar_activator>`"
        @mousedown.native="location === 'HistProjectTaktPlan' ? $router.push({name: 'HistProjectTaktPlan'}) :$router.push({name: 'ProjectTaktPlan'})"
        />
    </template>
    <template #content>
      <WaggonInfo>
        <template #header>
          <draggable
            class="display-flex"
            :style="`width: ${isEditMode?'calc(100% - 32px)':'100%'}`"
            :key="`workpackages${twaggon_id}`"
            :disabled="!isEditMode"
            animation="300"
            forceFallback="true"
            fallbackOnBody="true"
            :value="waggon.tworkpackages"
            @end="($event.newIndex - $event.oldIndex !== 0)?requestSnackbarUpdatePosition({
              url: [
                {projects: project_id},
                {trains: train_id},
                {taktareas: taktarea_id},
                {twaggons: twaggon_id},
                {tworkpackages: waggon.tworkpackages[$event.oldIndex]}
              ],
              update: {
                position: $event.newIndex - $event.oldIndex
              }
            }).then((payload) => {
              updateUObjectPosition(payload)
            }):''"
          >
          <WaggonInfoHeader
            v-for="(workpackage, index) in tworkpackages"
            :key="'header' + workpackage.id"
            :width="getHeaderWidth(workpackage.id)"
            :textcolor="workpackage.textcolor"
            :color="workpackage.color"
            :text="workpackage.id !== tworkpackage_id?workpackage.token:''"
            :wp_part="workpackage.id !== tworkpackage_id?workpackage.workpackage_part:''"
            :icon="workpackage.id !== tworkpackage_id? workpackage.icon:''"
            :cursor="isEditMode?'grab':''"
            @click.native="$router.push({
              name: !$route.name.includes('TaktPlanAddWorkPackage')?$route.name:'TaktPlanWorkPackageInfo',
              params: {
                tworkpackage_id: workpackage.id,
                }
              })"
          >
          <template v-if="isEditMode && workpackage.id === tworkpackage_id">
            <!-- OPTIONS TOGGLE -->
            <v-btn 
              icon 
              @click.prevent.stop="show_header_options = !show_header_options"
              >
              <TIcon
                :color="workpackage.textcolor"
                name="vertical-dots"
              />
            </v-btn>

            <!-- ACTUAL OPTIONS -->
            <TransitionAccordion>
              <!-- TODO: check width. value seems to be NOT correct. works for now. -->
              <PopUpOverlay
                v-if="show_header_options"
                style="z-index: 20;"
                :width="`${2 * 140}px`"
                :margin="8"
                :position_css="`
                  right: 10px;
                  transform: translate(0%, 100%);
                `"
                :is_no_cancel="true"
                @closeOverlay="show_header_options = false"
                :z_index="1"
              >
                <template #body>
                  <div class="workpackage-sidebar-option-buttons">
                    <ClickablePopUpIcon
                        icon="pencil"
                        color="var(--primary)"
                        description="edit"
                        @selected="edit_wp = workpackage, show_header_options = false"
                      />
                      <ClickablePopUpIcon
                        icon="copy"
                        color="var(--primary)"
                        description="copy"
                        @selected="
                          getNestedWorkPackageCopy(workpackage.id, false, 't').then(work_package => {
                            updateWBLObject({
                            path: [
                            {workpackage: ''}
                            ],
                            update: work_package
                            }),
                            $router.push({
                              name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                              params: { workpackage_id: 'create' }
                            })
                          }), show_header_options = false
                        "
                      />
                      <ClickablePopUpIcon
                        icon="copy-extra"
                        color="var(--primary)"
                        description="copy incl. steps"
                        @selected="
                          getNestedWorkPackageCopy(workpackage.id, true, 't').then(work_package => {
                            updateWBLObject({
                            path: [
                            {workpackage: ''}
                            ],
                            update: work_package
                            }),
                            $router.push({
                              name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                              params: { workpackage_id: 'create' }
                            })
                          }), show_header_options = false
                        "
                      />
                      <ClickablePopUpIcon
                        v-if="hasPermission('Taktprint CREATE')"
                        icon="print"
                        color="var(--primary)"
                        description="print"
                        @selected="
                            $router.push({
                              name: 'ProjectWalletPrint'
                            })
                        "
                      />
                      <div class="workpackage-sidebar-deletebutton-wrapper">
                      <StandardDeleteButton
                        :zoom="1.3"
                        style="margin-right: 0px !important; margin-top: 2px"
                        @clickDelete="requestSnackbarDelete({
                            url: [
                              {projects: project_id},
                              {trains: train_id},
                              {taktareas: taktarea_id},
                              {twaggons: twaggon_id},
                              {tworkpackages: workpackage.id}
                            ],
                            selector: 'target'
                          }).then((payload) => {
                            waggon.tworkpackages.length > 1?
                            $router.push({
                              name: 'TaktPlanWorkPackageInfo',
                              params: {
                                tworkpackage_id: index === waggon.tworkpackages.length-1?waggon.tworkpackages[index-1]:waggon.tworkpackages[index+1],
                              }
                              }).then(() => {
                                deleteUObject(payload);
                              })
                              :
                              $router.push({
                                name: 'TaktPlanAddWorkPackage',
                              }).then(() => {
                                deleteUObject(payload);
                              })
                          })"
                        />
                        <TText
                          style="margin-top: 3px"
                          value="delete"
                          :size="9"
                          color="var(--primary)"
                        />
                        </div>
                  </div>
                </template>
              </PopUpOverlay>
            </TransitionAccordion>
            
          <template v-if="false">
          <v-btn
            icon
            :color="workpackage.textcolor"
            small
            @click="edit_wp = workpackage"
            >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                :color="workpackage.textcolor"
                v-on="on"
                @click.prevent.stop="
                getNestedWorkPackageCopy(workpackage.id, true, 't').then(work_package => {
                    updateWBLObject({
                    path: [
                    {workpackage: ''}
                    ],
                    update: work_package
                    }),
                    $router.push({
                      name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                      params: { workpackage_id: 'create' }
                    })
                  })
                "
                >
                <v-icon small>content_copy</v-icon>
              </v-btn>
            </template>
            <span>Copy to Workbench with Steps</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                :color="workpackage.textcolor"
                v-on="on"
                @click.prevent.stop="
                getNestedWorkPackageCopy(workpackage.id, false, 't').then(work_package => {
                    updateWBLObject({
                    path: [
                    {workpackage: ''}
                    ],
                    update: work_package
                    }),
                    $router.push({
                      name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                      params: { workpackage_id: 'create' }
                    })
                  })
                "
                >
                <v-icon small>file_copy</v-icon>
              </v-btn>
            </template>
            <span>Copy to Workbench without Steps</span>
          </v-tooltip>
          <StandardDeleteButton
            :zoom="1"
            @clickDelete="requestSnackbarDelete({
                url: [
                  {projects: project_id},
                  {trains: train_id},
                  {taktareas: taktarea_id},
                  {twaggons: twaggon_id},
                  {tworkpackages: workpackage.id}
                ],
                selector: 'target'
              }).then((payload) => {
                waggon.tworkpackages.length > 1?
                $router.push({
                  name: 'TaktPlanWorkPackageInfo',
                  params: {
                    tworkpackage_id: index === waggon.tworkpackages.length-1?waggon.tworkpackages[index-1]:waggon.tworkpackages[index+1],
                  }
                  }).then(() => {
                    deleteUObject(payload);
                  })
                  :
                  $router.push({
                    name: 'TaktPlanAddWorkPackage',
                  }).then(() => {
                    deleteUObject(payload);
                  })
              })"
            />
          </template>
          </template>
        </WaggonInfoHeader>


        </draggable>
          <WaggonInfoHeaderAdd
            v-if="isEditMode"
            @click.native="$router.push({
              name: 'TaktPlanAddWorkPackage'
              })"
          />
        </template>
        <template #body>
          <router-view></router-view>
        </template>
      </WaggonInfo>
      <EditTWorkPackageDialog
        v-if="edit_wp"
        :workpackage="edit_wp"
        @closeDialog="edit_wp = false"
        @changeWP="changeTWorkPackage({
          project_id: project_id,
          train_id: train_id,
          taktarea_id: taktarea_id,
          twaggon_id: twaggon_id,
          tworkpackage_id: edit_wp.id,
          new_wp: $event.new_wp,
          snackbar_call: $event.snackbar_call
        }).then(() => {
          edit_wp = false
          })"
      />
    </template>
  </SideBar>
</template>

<script>
import { mapActions } from 'vuex';

import draggable from "vuedraggable";

import SideBar from '@/components/ProjectTaktPlan/SideBar.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
import EditTWorkPackageDialog from '@/components/ProjectTaktPlan/EditTWorkPackageDialog.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue'
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue'
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue';
import ClickablePopUpIcon from '@/components/WorkPackageWIP/ClickablePopUpIcon.component.vue';
import TText from '@/components/Taktify/TText.component.vue';

import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'
import { SideBarMixin } from '@/mixins/SideBar.mixin.js'
export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'waggon', 'location'],
  components: {
    SideBar,
    Activator,
    draggable,
    EditTWorkPackageDialog,
    TIcon,
    TransitionAccordion,
    PopUpOverlay,
    ClickablePopUpIcon,
    TText,
  },
  mixins: [
    WaggonInfoMixin,
    SideBarMixin
  ],
  data: () => ({
    edit_wp: false,
    show_header_options: false,
  }),
  created(){
    // console.log( this.$store.state.Ultra );
  },
  watch: {
    tworkpackage_id() {
      this.show_header_options = false;
    }
  },
  computed: {
    tworkpackages(){
      if (this.location === 'HistProjectTaktPlan') {
        return this.getUObjects({type: 'histtworkpackages', ids: this.waggon.histtworkpackages});
      } else {
        return this.getUObjects({type: 'tworkpackages', ids: this.waggon.tworkpackages});
      }
    }
  },
  methods: {
    ...mapActions('WorkPackage', [
      'changeTWorkPackage',
    ]),
  },
}
</script>
<style>
  .workpackage-sidebar-option-buttons {
    display: flex;
    width: 100%;
    align-items: center;
    /* grid-gap: 8px;
    padding: 16px; */
    justify-content: space-between;
  }
  .workpackage-sidebar-deletebutton-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>
